<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2022-08-24 14:41:46
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-07-17 10:47:14
 * @FilePath: /wemeet-admin-new/src/views/form/components/formEdit.vue
 * @Description: 
 * Copyright (c) 2024 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer v-model="dialogFormVisible" size="60%" :title="title" @close="close">
    <el-form ref="formRef" label-width="80px" :model="form" :rules="rules">
      <el-form-item label="问卷名称" prop="title">
        <el-input v-model.trim="form.title" />
      </el-form-item>
      <el-form-item label="问卷封面" :label-width="90">
        <el-upload
          accept=".png,.jpeg,.jpg"
          action="#"
          class="upload-demo"
          :file-list="form.coverList"
          :http-request="upCover"
          :limit="1"
          list-type="picture-card"
          :on-error="handleError"
          :on-exceed="handleExceed"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
        >
          <el-icon class="el-icon--upload"><upload-filled /></el-icon>
          <div class="el-upload__text">
            <em>点击上传图片</em>
          </div>
        </el-upload>
      </el-form-item>

      <el-form-item label="详情介绍">
        <Toolbar
          :default-config="toolbarConfig"
          :editor="editorRef"
          :mode="mode"
          style="border-bottom: 1px solid #ccc"
        />
        <Editor
          v-model="form.description"
          :default-config="editorConfig"
          :mode="mode"
          style="height: 300px; overflow-y: auto"
          @onCreated="handleCreated"
        />
      </el-form-item>
    </el-form>

    <vab-upload ref="vabUploadRef" :limit="1" name="file" :size="2" url="/upload" @addImg="handleAddImg" />

    <div class="demo-drawer__footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="save">提交</el-button>
    </div>
  </el-drawer>
</template>

<script>
  import {
    defineComponent,
    getCurrentInstance,
    defineAsyncComponent,
    reactive,
    toRefs,
    onMounted,
    onBeforeUnmount,
    shallowRef,
  } from 'vue'
  import { editQuestioniareList, addQuestioniareList } from '@/api/form'
  import { useStore } from 'vuex'
  import { upLoadImg } from '@/api/active'

  import VabQuill from '@/extra/VabQuill'
  import VabUpload from '@/extra/VabUpload'
  import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
  import { Boot } from '@wangeditor/editor'
  import '@wangeditor/editor/dist/css/style.css'
  import MyButtonMenu from './material'

  // 引入下拉数选择
  export default defineComponent({
    name: 'FormEdit',
    components: {
      VabQuill,
      VabUpload,
      Editor,
      Toolbar,
    },
    props: {
      eventId: {
        type: String,
        default: '',
      },
    },
    emits: ['fetch-data'],
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      // 自定义手机验证

      const state = reactive({
        formRef: null,
        form: {
          coverList: [],
          details: '',
        },
        departmentData: [],
        rules: {
          title: [{ required: true, trigger: 'blur', message: '请输入问卷名称' }],
        },
        title: '',
        dialogFormVisible: false,
        roleList: [],
        vabUploadRef: null,
      })

      // 图片上传相关接口
      const upCover = async (e) => {
        let upData = new FormData()
        upData.append('file', e.file)
        const { data } = await upLoadImg(upData)
        state.form.coverUrl = data
      }

      const handleError = (err, file) => {
        proxy.$baseMessage(
          `文件[${file.raw.name}]上传失败,文件大小为${_.round(file.raw.size / 1024, 0)}KB`,
          'error',
          'vab-hey-message-error'
        )
      }

      const handleExceed = (files) => {
        proxy.$baseMessage(
          `当前限制选择 ${proxy.limit} 个文件，本次选择了
             ${files.length}
             个文件`,
          'error',
          'vab-hey-message-error'
        )
      }

      const handleRemove = (file, fileList) => {
        state.form.coverUrl = ''
      }

      const handleAddImg = async (e) => {
        state.form.description += `<img src="${e}" />`
      }

      const showEdit = async (row) => {
        console.log(row)
        if (!row) {
          state.title = '添加'
        } else {
          state.title = '编辑'
          state.form = Object.assign({}, row)
          if (row.coverUrl) {
            state.form.coverList = [{ name: 'cover', url: row.coverUrl }]
          }
        }
        // handleCreated()

        state.dialogFormVisible = true
      }
      const close = () => {
        state['formRef'].resetFields()
        state.form = {}
        state.dialogFormVisible = false
      }
      const save = () => {
        state['formRef'].validate(async (valid) => {
          if (valid) {
            let msg = ''
            console.log(state.form, '123123123123')
            if (state.title == '添加') {
              let data = await addQuestioniareList(state.form)
              msg = data.msg
            } else {
              let data = await editQuestioniareList(state.form)
              msg = data.msg
            }
            proxy.$baseMessage(msg, 'success', 'vab-hey-message-success')
            emit('fetch-data')
            close()
          }
        })
      }

      const toolbarConfig = {
        excludeKeys: ['fullScreen', 'group-video'],
        // insertKeys: {
        //   index: 0, // 自定义插入的位置
        //   keys: ['uploadAttachment'], // “上传附件”菜单
        // },
      }

      // const menu1Conf = {
      //   key: 'uploadAttachment', // 定义 menu key ：要保证唯一、不重复（重要）
      //   factory() {
      //     return new MyButtonMenu() // 把 `YourMenuClass` 替换为你菜单的 class
      //   },
      // }

      // Boot.registerMenu(menu1Conf)

      const editorConfig = {
        placeholder: '请输入内容...',
        MENU_CONF: {
          uploadImage: {
            async customUpload(res, insertFn) {
              let upData = new FormData()
              upData.append('file', res)
              const { data } = await upLoadImg(upData)
              insertFn(data, res.name)
            },
          },
        },
      }

      const editorRef = shallowRef()
      const handleCreated = (editor) => {
        editorRef.value = editor // 记录 editor 实例，重要！
        editor.on('uploadAttachment', () => {
          console.log('我触达了素材库上传')
        })
      }

      onBeforeUnmount(() => {
        const editor = editorRef.value
        if (editor == null) return
        editor.destroy()
      })

      return {
        ...toRefs(state),
        showEdit,
        close,
        save,
        handleRemove,
        handleError,
        handleExceed,
        upCover,
        handleAddImg,
        toolbarConfig,
        editorConfig,
        mode: 'default',
        handleCreated,
        editorRef,
      }
    },
  })
</script>
<style>
  .w-e-toolbar {
    z-index: 2 !important;
  }
  .w-e-menu {
    z-index: 2 !important;
  }
  .w-e-text-container {
    z-index: 1 !important;
  }
</style>
<style lang="scss" scoped>
  .demo-drawer__footer {
    position: fixed;
    right: 20px;
    bottom: 10px;
  }
</style>
